import {Injectable, inject} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable, map} from "rxjs";
import {TrainVoucher, TrainVoucherListQuery, TrainVoucherPage} from "../models/train-voucher.model";
import {TrainProviderExternalData} from "../models/train-provider-settings.model";

export function toCursorPage<T>(response: unknown): {list: T[]; cursor: string} {
  if (Array.isArray(response)) {
    return {list: response as T[], cursor: ""};
  }
  const envelope = (response ?? {}) as {list?: T[]; cursor?: unknown};
  return {
    list: envelope.list ?? [],
    cursor: typeof envelope.cursor === "string" ? envelope.cursor : "",
  };
}

export function toTrainVoucherPage(response: unknown): TrainVoucherPage {
  return toCursorPage<TrainVoucher>(response);
}

@Injectable({providedIn: "root"})
export class ThreePLTrainHttpService {
  private readonly baseUrl = "/threepls/train";
  private readonly http = inject(HttpClient);

  list(query: TrainVoucherListQuery): Observable<TrainVoucherPage> {
    let params = new HttpParams()
      .set("from", query.from)
      .set("to", query.to)
      .set("active", query.active)
      .set("limit", query.limit);
    if (query.cursor) {
      params = params.set("cursor", query.cursor);
    }
    return this.http.get<unknown>(this.baseUrl, {params}).pipe(map(toTrainVoucherPage));
  }

  getOne(voucherId: string): Observable<TrainVoucher> {
    return this.http.get<TrainVoucher>(`${this.baseUrl}/${voucherId}`);
  }

  getThirdPartyService(serviceId: string): Observable<TrainVoucher> {
    return this.http.get<TrainVoucher>(`/thirdPartyService/${serviceId}`);
  }

  updateService(voucherId: string, voucher: TrainVoucher): Observable<TrainVoucher> {
    return this.http.post<TrainVoucher>(`${this.baseUrl}/${voucherId}`, voucher);
  }

  completeService(voucherId: string): Observable<TrainVoucher> {
    return this.http.post<TrainVoucher>(`${this.baseUrl}/${voucherId}/complete`, {});
  }

  cancelService(voucherId: string): Observable<TrainVoucher> {
    return this.http.post<TrainVoucher>(`${this.baseUrl}/${voucherId}/cancel`, {});
  }

  getProviderExternalData(): Observable<TrainProviderExternalData> {
    return this.http.get<TrainProviderExternalData>("/threepls/settings/1/providerExternalData");
  }
}
